var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaypalSmall = function SvgPaypalSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 16,
    fill: "url(#paypalSmall_svg__a)",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28356A",
    fillRule: "evenodd",
    d: "m8.922 12.22.15-.996-.333-.008h-1.59l1.105-7.354a.1.1 0 0 1 .03-.058.1.1 0 0 1 .06-.023h2.68c.89 0 1.503.195 1.824.578.15.18.246.368.292.575.049.218.05.477.002.794l-.003.023v.203l.15.089q.19.105.305.244.193.233.246.581a2.6 2.6 0 0 1-.035.844c-.068.37-.18.691-.329.955a1.9 1.9 0 0 1-.521.6 2.1 2.1 0 0 1-.703.332q-.39.107-.878.107h-.208a.62.62 0 0 0-.408.157.67.67 0 0 0-.212.399l-.016.09-.264 1.756-.012.064q-.005.029-.017.038a.04.04 0 0 1-.027.01z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ADD0E6",
    fillRule: "evenodd",
    d: "m13.432 5.773-.028.165c-.353 1.906-1.562 2.564-3.107 2.564h-.786a.39.39 0 0 0-.377.34l-.517 3.44c-.02.129.075.245.199.245h1.394a.34.34 0 0 0 .332-.297l.013-.075.263-1.75.017-.095a.34.34 0 0 1 .331-.298h.209c1.351 0 2.409-.576 2.718-2.243.13-.696.062-1.278-.28-1.687a1.3 1.3 0 0 0-.381-.309",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EFF6",
    fillRule: "evenodd",
    d: "M13.062 5.62a3 3 0 0 0-.344-.08 4 4 0 0 0-.693-.053h-2.1a.3.3 0 0 0-.146.034.35.35 0 0 0-.186.263l-.447 2.972-.013.087a.39.39 0 0 1 .378-.34h.786c1.544 0 2.754-.658 3.107-2.563q.016-.085.027-.165a2 2 0 0 0-.37-.155",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.593 5.784a.35.35 0 0 1 .186-.263.3.3 0 0 1 .145-.034h2.101q.374 0 .693.053a3 3 0 0 1 .344.08l.08.026q.155.054.29.128c.105-.704-.001-1.183-.364-1.617-.4-.478-1.12-.683-2.044-.683h-2.68a.39.39 0 0 0-.379.34l-1.116 7.43c-.022.147.086.28.227.28h1.655z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paypalSmall_svg__a",
    x1: 0,
    x2: 21.237,
    y1: 0,
    y2: 15.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#019ADD"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaypalSmall);
export default ForwardRef;